import styled from 'styled-components'
import fonts from '../../const/fonts'
import { colors } from '../../const/theme'
import { BadgeWrapperProps } from './typings'

export const BadgeWrapper = styled.div<BadgeWrapperProps>`
  width: ${({ width }) => width || '100%'};
  margin: 12px 24px;
  @media (max-width: 415px) {
    width: 30%;
  }
`

export const SubTitle = styled.div`
  text-align: center;
  height: 24px;
  border: 1px ${colors.gray};
  background: ${colors.lightGrey};
  border-radius: 23px;
  min-width: 70px;
  font-size: ${fonts.medium};
`
